import React from 'react';
import {Box, Divider, Typography} from '@mui/material';
import AccessSettings from './AccessSettings';
import StudentProfileAccessRestrictions from './StudentProfileAccessRestrictions';

const ManageAccessTab = () => (
    <Box display="flex" flexDirection="column" gap={3} pb={3}>
        <Box>
            <Typography variant="h6" fontWeight="bold" sx={{mt: 1, mb: 0.5}}>
                Role permissions
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{mb: 1}}>
                Configure what each role can view, edit, or hide across student, applicant, and staff profile sections.
            </Typography>
            <AccessSettings/>
        </Box>
        <Divider/>
        <StudentProfileAccessRestrictions/>
    </Box>
);

export default ManageAccessTab;
